import { Typography } from '@material-ui/core'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import CorrectShoesImage from 'core/assets/images/correct-shoes.png'
import IncorrectShoesImage from 'core/assets/images/incorrect-shoes.png'
import i18n from 'core/common/i18n'
import { IconButton } from 'core/components/Core'
import Modal from 'core/components/Modal'
import * as S from './style'

function ProductDialogTitleTips({ open, onClose }) {
  return (
    <Modal
      title={
        <div className="d-flex justify-between">
          <Typography variant="h5">
            {i18n.t('productNew.basicData.productTitleTipsTitle')}
          </Typography>

          <IconButton
            size="small"
            onClick={onClose}
            aria-label={i18n.t('productNew.basicData.closeButtonAriaLabel')}
          >
            <CloseOutlinedIcon />
          </IconButton>
        </div>
      }
      open={open}
      onCancel={onClose}
      maxWidth="md"
    >
      <div className="d-flex">
        <div className="mr-3">
          <div style={{ width: '90%' }}>
            <Typography variant="body1">
              {i18n.t('productNew.basicData.productTitleTipsSubtitle')}
            </Typography>

            <S.List className="my-3">
              <Typography variant="body1" component="li">
                {i18n.t('productNew.basicData.installmentConditions')}
              </Typography>

              <Typography variant="body1" component="li">
                {i18n.t('productNew.basicData.installment')}
              </Typography>

              <Typography variant="body1" component="li">
                {i18n.t('productNew.basicData.discount')}
              </Typography>

              <Typography variant="body1" component="li">
                {i18n.t('productNew.basicData.productVariations')}
              </Typography>
            </S.List>

            <Typography variant="body1">
              {i18n.t('productNew.basicData.productTitleTipsNotice')}
            </Typography>
          </div>
        </div>

        <div className="d-flex">
          <div className="mr-2">
            <img
              src={CorrectShoesImage}
              alt={i18n.t('productNew.basicData.correctImageAltText')}
              className="max-w-100"
            />
          </div>

          <div>
            <img
              src={IncorrectShoesImage}
              alt={i18n.t('productNew.basicData.incorrectImageAltText')}
              className="max-w-100"
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ProductDialogTitleTips
